// extracted by mini-css-extract-plugin
export var blockquote = "RichText-module--blockquote--5e174";
export var root = "RichText-module--root--36822";